import getIn from '@alexaivars/get-in';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import createResourceDataReducer from 'lib/createResourceDataReducer';
import createResourceListReducer from 'lib/createResourceListReducer';
import createResourceStatusReducer from 'lib/createResourceStatusReducer';
import { STATES } from 'lib/constants';
import { NAME } from './constants';
import {
  LOAD_LIST,
  DELETE_FOLLOWING,
  ADD_FOLLOWING,
  CLEAR_FOLLOWING_LIST,
} from './actions';

const following = combineReducers({
  data: createResourceDataReducer(
    LOAD_LIST,
    ADD_FOLLOWING,
    DELETE_FOLLOWING,
    CLEAR_FOLLOWING_LIST,
  ),
  list: createResourceListReducer(
    LOAD_LIST,
    ADD_FOLLOWING,
    DELETE_FOLLOWING,
    CLEAR_FOLLOWING_LIST,
  ),
  status: createResourceStatusReducer([
    LOAD_LIST,
    ADD_FOLLOWING,
    DELETE_FOLLOWING,
    CLEAR_FOLLOWING_LIST,
  ]),
});

const getFollowingData = state => getIn(state, [NAME, 'data'], {});
const getFollowingList = state => getIn(state, [NAME, 'list'], []);

export const isFollowingNewsroom = (state, id) => {
  const data = getFollowingData(state);
  const list = getFollowingList(state);
  const newsroomIds = list.map(id => String(data[id].attributes.pressroomId));
  return newsroomIds.indexOf(String(id)) > -1;
};

export const getFollowingIdByNewsroomId = (state, id) => {
  const data = getFollowingData(state);
  const list = getFollowingList(state);
  const item = list
    .map(id => data[id])
    .find(item => String(item.attributes.pressroomId) === String(id));
  return item ? item.id : null;
};

export const getFollowingStatus = state =>
  getIn(state, [NAME, 'status'], STATES.PENDING);

export const getFollowingPressroomIds = createSelector(
  [getFollowingList, getFollowingData, getFollowingStatus],
  (ids, data, status) => {
    return ids.map(id => {
      return data[id].attributes.pressroomId;
    });
  },
);

export const getFollowing = createSelector(
  [getFollowingList, getFollowingData, getFollowingStatus],
  (ids, data, status) => {
    return ids.map(id => ({ id, ...data[id].attributes }));
  },
);

export default following;
